<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" :initialFocus="activeElement" @close="closeModal">
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="min-h-screen px-4 text-center flex">
          <DialogOverlay class="fixed inset-0 bg-black opacity-50" />

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="
                inline-block
                w-full
                max-w-screen-sm
                p-6
                m-auto
                overflow-hidden
                text-left
                align-middle
                transition-all
                transform
                bg-white
                shadow-xl
                rounded
              "
            >
              <div class="py-4">
                <img
                  class="mx-auto"
                  src="@/assets/images/inactive-icon.svg"
                  ref="inactiveRef"
                />
              </div>

              <div class="py-4">
                <h4 class="text-brand-black text-xl text-center">
                  This Application Link is Inactive
                </h4>
              </div>

              <div class="py-4">
                <p class="text-brand-black">
                  The landlord or property manager has currently disabled this
                  application link. If you think this is an error, please
                  contact the landlord directly at:
                </p>
                <br />
                <p class="text-brand-black font-bold text-center">
                  {{ getCurrentApplicationTemplate.landlord.email }}
                </p>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay
} from "@headlessui/vue"

import { mapGetters } from "vuex"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay
  },
  computed: {
    ...mapGetters(["getCurrentApplicationTemplate"]),
    activeElement() {
      return document.activeElement
    }
  },
  methods: {
    closeModal() {
      this.$emit("close")
    }
  }
}
</script>
